module.exports = __webpack_public_path__ + "img/Photos_Empanadas_reservation_web-w.f681da25.jpg";